module.exports = __webpack_public_path__ + "img/t2-c3.3df30ffc.png";